<div class="alert-message" [ngClass]="type" [ngStyle]="{'margin-bottom': mb, 'margin-top': mt}">
    <div class="close-wrapper" *ngIf="canClose" (click)="onClickClose()">CLOSE</div>
    <ng-content></ng-content>
</div>
